export default __webpack_public_path__ + "static/media/lesly.8eeb9c4d.png";